import { isUndefined } from '@aloft/toolkit-shared';

import { useEffect, useState } from 'react';

import { fetchGetCoordinatesForAddressesAPI } from '../api/toolkitComponents.ts';
import { useToolkitContext } from '../api/toolkitContext.ts';

type LatLngFromAddressState =
  | {
      latLng: undefined;
      status: 'idle' | 'pending' | 'error';
    }
  | {
      latLng: { lat: number; lng: number };
      status: 'loaded';
    };

export const useLatLngFromAddress = (address?: string, shouldGeocode = true) => {
  const [state, setState] = useState<LatLngFromAddressState>({
    latLng: undefined,
    status: 'idle',
  });
  const { fetcherOptions } = useToolkitContext();

  useEffect(() => {
    const getGeocodedResult = async () => {
      try {
        setState({ latLng: undefined, status: 'pending' });

        if (!address) {
          throw new Error('No address provided');
        }

        const result = await fetchGetCoordinatesForAddressesAPI({
          ...fetcherOptions,
          queryParams: { addresses: [encodeURIComponent(address)] },
        });

        const { lat, lng } = result[0] as { lat: number; lng: number };

        if (isUndefined(lat) || isUndefined(lng)) {
          throw new Error('No lat/lng found');
        }

        setState({ latLng: { lat, lng }, status: 'loaded' });
      } catch (err) {
        console.warn(err);
        setState({ latLng: undefined, status: 'error' });
      }
    };

    if (shouldGeocode) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      getGeocodedResult();
    } else {
      setState({ latLng: undefined, status: 'idle' });
    }
  }, [address, fetcherOptions, shouldGeocode]);

  return state;
};
